import { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectTgsSwitch,
  tgsHandleOpenMachineController,
  tgsHandleUnSelectIndividualMachine,
  tgsSpecificLocationUnselectMachinesHandler,
} from 'shared/slice/tgsSwitchSlice';

import { useMediaQuery } from 'react-responsive';

import styled from 'styled-components';
import MasterControlBySwitch from 'shared/components/commonComponentsMC/MasterControlBySwitch';
import IntegratedSwitchLocations from 'shared/components/commonComponentsMC/IntegratedSwitchLocations';
import {
  selectMCIsExpanded,
} from 'shared/slice/MCIsExpandedSlice';
import { selectUnits } from 'shared/slice/unitsSlice';
import { handleResetAllSelectBySwitch } from 'shared/slice/masterControlBySwitchSelectSlice';
import { handleResetAllSelectByLocation } from 'shared/slice/masterControlSelectByLocationSlice';
import { useGetScheduleQueries, useSetZoneOpeningsState } from 'shared/hooks';
import {
  getTgsZones,
} from 'shared/services';
import { useQuery } from 'react-query';
import { handleAccessToken } from 'shared/slice/userSlice';
import {
  EssTgsTesContext,
} from 'shared/context/contextOfEssTgsTes';
import { loopMachinesHandler } from 'shared/helpers/ess-tgs-tes-mc';
import { filterZonesWithDevices } from 'shared/helpers/locationsCache';
import { useSetOpenMasterControl } from 'shared/hooks/ess_tgs_tes_hooks/useSetOpenMasterControl';

const TgsMain = ({ isMasterControl }) => {
  const isMobile = useMediaQuery({ query: '(max-width:600px)' });


  const { tgsSwitch,flatTgsSwitch } = useSelector(selectTgsSwitch);
  const MCIsExpanded = useSelector(selectMCIsExpanded);
  const { masterControl } = MCIsExpanded.tgs;

  const unitsStatus = useSelector(selectUnits);
  const { isF } = unitsStatus;


  const { messageBoxHandler } = useContext(EssTgsTesContext);






  const dispatch = useDispatch();

  useGetScheduleQueries(flatTgsSwitch, 'TGS');


  useSetOpenMasterControl('tes', isMobile);












  useSetZoneOpeningsState(
    flatTgsSwitch,
    masterControl,
    tgsHandleOpenMachineController,
    'tgs'
  );



















  const { data: tgsZones } = useQuery(['tgsZones','structured'], ()=>getTgsZones({structured:true}).then(filterZonesWithDevices), {
    enabled: !!handleAccessToken,
    staleTime: Infinity,
  });

  const integratedButtonHandler = (
    id,
    state,
    scope,
    temp,
    data,
    type,
    specificLocation
  ) => {





















    loopMachinesHandler(
      id,
      state,
      scope,
      type,
      temp,
      data,
      isF,
      tgsZones,
      'TGS',
      flatTgsSwitch,
      dispatch,
      tgsHandleUnSelectIndividualMachine,
      tgsSpecificLocationUnselectMachinesHandler,
      handleResetAllSelectBySwitch,
      handleResetAllSelectByLocation,
      messageBoxHandler,
      tgsSwitch
    );





























  };























































































































































































































































































































































































































































































































































































































  return (
    <Wrapper>
      {isMasterControl || (
        <Section>
          <MasterControlBySwitch
            swtName='tgs'
            buttonHandler={integratedButtonHandler}





          />
        </Section>
      )}

      <Section>
        <IntegratedSwitchLocations
          swtName='tgs'
          buttonHandler={integratedButtonHandler}





        />
      </Section>
    </Wrapper>
  );
};

export default TgsMain;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
const Section = styled.section`
  &:first-child {
    margin-bottom: 8px;
  }
`;
